'use client';

import dynamic from 'next/dynamic';
import { HeroCarouselProps } from '@/components/organisms/hero-carousel/types';

// Lazy-load the organism so the react-slick bundle stays out of the SSR critical
// path. ssr defaults to true (not disabled) so slide 0 still renders server-side
// for LCP.
const HeroCarousel = dynamic(() => import('@/components/organisms/hero-carousel'));

const HeroCarouselClientWrapper = (props: HeroCarouselProps) => <HeroCarousel {...props} />;

export default HeroCarouselClientWrapper;
